module.exports = __webpack_public_path__ + "img/ubuntu-icon.13369cc0.svg";